// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  initialValues,
  patternSet,
} from './initialValues'

// blends initial antenna details values with unit type based on user preferences.
const getNewAntennaInitialValues = (patterns, unitType) => {
  Object.keys(patterns).map(k => {
    patterns[k] = patternSet
  })

  // set the first pattern set from APIs response about pat/pol patterns
  // to be the default displayed set.
  const patternsSetDisplayed = Object.keys(patterns)[0]
  return {
    ...initialValues,
    diameterUnit: unitType,
    patterns,
    patternsSetDisplayed,
    unitType,
  }
}

export default getNewAntennaInitialValues
